<template>
  <div class="page-header mb-3">
    <div class="page-title">
      <h4>
        <span class="back-link" @click="back()"> {{ this.$t(title) }} </span>
        {{ this.mainPage ? " / " + this.mainPage : "" }}
      </h4>
      <h6>{{ this.$t(title1) }}</h6>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    mainPage: {
      type: String,
      default: "",
    },
    title1: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    back() {
      if (this.mainPage) this.$router.back();
    },
  },
};
</script>

<style scoped>
.page-header .btn-added:hover {
  color: white;
}

.back-link {
  cursor: pointer;
}
</style>
